import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

// Styles
const s = require('./PortalSearchInitial.css');
const searchIcon = require('./../../../assets/search-icon-thin.svg');
const pacificBackground = require('./../../../assets/pacific-background-font.png');
const arrowBackground = require('./../../../assets/pacific-background-arrow.png');

// Props
interface IPortalSearchInitialProps {
    userPermissionId: number;
}

// Component
@observer
export class PortalSearchInitial extends React.Component<IPortalSearchInitialProps, {}> {
    static get defaultProps(): IPortalSearchInitialProps {
        return {
            userPermissionId: 0
        };
    }

    @computed private get instructions(): string {
        let ins: string = '';

        if (this.props.userPermissionId >= 3) {
            ins += 'Check stock and prepare order';
        } else if (this.props.userPermissionId === 2) {
            ins += 'Check stock and view prices';
        } else {
            ins += 'Check available items';
        }

        ins += ' by searching parts you need using the bar on top';

        return ins;
    }

    public render() {
        return (
            <div className={s.container}>
                <div className={s.middle}>
                    <img className={s.icon} src={searchIcon} alt="" />
                    <p>
                        <strong>{this.instructions}</strong>
                        <em>Enter at least 2 characters in any of search fields</em>
                    </p>
                </div>

                <div className={s.background}>
                    <img className={s.pacific} src={pacificBackground} alt="" />
                    <img className={s.arrow} src={arrowBackground} alt="" />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalSearch/PortalSearchInitial.tsx